<template>
    <b-card no-body class="card-smallLight">
        <div class="left">
            <div class="header">
              <h3>
                <PuSkeleton :loading="isLoading" :count="1" width='120px'>                
                  {{title}}
                </PuSkeleton>
              </h3>
              <PuSkeleton circle :loading="isLoading" height="40px" width="40px">                
                <div class="number" :class="{negative : isNegative}">
                      {{number}}                         
                </div>
              </PuSkeleton>
            </div>


          <PuSkeleton :loading="isLoading" :count="1">
            <div class="title">
              <h4>{{resultOne}}</h4>
              <div class="result"  :class="{negative : isNegative}">
                {{difference}}
              </div>  
            </div>
          </PuSkeleton> 


          <PuSkeleton :loading="isLoading" :count="1">
            <div class="line">
              <b-progress height="1.75rem" :value="value" :max="max" class="positive" :class="{negative : isNegative}">
              </b-progress>
              <div class="date">
                {{date}}
              </div>
            </div>
          </PuSkeleton>


          <h4 class="secondTitle">
            <PuSkeleton :loading="isLoading" :count="1">
              {{resultTwo}}
            </PuSkeleton>
          </h4>

          <PuSkeleton :loading="isLoading" :count="1">
            <div class="line grey">
              <b-progress height="1.75rem" :value="valueTwo" :max="max">
              </b-progress>                        
              <div class="date">
                {{dateTwo}}
              </div>
            </div>
          </PuSkeleton>


        </div>
    </b-card>
</template>


<script>
// import lineChart from '../chart/Line'
import card from '../card/Card'
//
export default {
  name: "CardSmallLight",
  components:{ 
    // lineChart
  },
  mixins: [card],
  props:{
    link:{
      type:String,
      default:'#',
    },
    parent:{
      type:String,
      default:'Parent',
    },
    title:{
      type:String,
      default:'Mon titre',
    },
    number:{
      type:String,
      default:'0',
    },
    resultOne:{
      type:String,
      default:'0',
    },
    resultTwo:{
      type:String,
      default:'#',
    },
    date:{
      type:String,
      default:'20 septembre 2019',
    },
    dateTwo:{
      type:String,
      default:'20 septembre 2019',
    },
  },
  data(){
    return {
        isLoading:true,
    }
  },
  methods : {
    majData(){
      this.getNegatifOrNot(this.number);
      this.getPourcentBetween(this.resultOne, this.resultTwo);
    }
  },  
  mounted (){

  },
  created(){
    setTimeout(() => {
      this.isLoading = false;
      this.majData();
    },2000)      
  }

}
</script>